import { Link } from "react-router-dom";
import { footerGroups, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5 lg:gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-megaphone-fill text-lg" aria-hidden="true" />
              </span>
              <span className="font-display text-lg font-bold tracking-tight text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              {siteInfo.description}
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 font-label text-sm">
              <span className="inline-flex items-center gap-2 text-background-100">
                <i className="ri-mail-line text-accent-400" aria-hidden="true" />
                <a href={`mailto:${siteInfo.email}`} rel="nofollow" className="hover:text-accent-300">
                  {siteInfo.email}
                </a>
              </span>
              <span className="inline-flex items-center gap-2 text-background-100">
                <i className="ri-shield-keyhole-line text-accent-400" aria-hidden="true" />
                全程支持匿名
              </span>
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h3 className="font-display text-base text-background-50">{group.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="font-label text-sm text-background-200 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 font-label text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {siteInfo.name}. 保留所有权利。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>投稿内容由网友提供，仅代表分享者观点</span>
            <Link to="/about" className="transition-colors hover:text-accent-300">
              内容原则
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}